// extracted by mini-css-extract-plugin
module.exports = {"overlay":"tutorial_overlay__1E70i","container":"tutorial_container__2ufIf","close":"tutorial_close__cAov5","link":"tutorial_link__3YfXV"};